import { render, staticRenderFns } from "./index.vue?vue&type=template&id=3b0edee2&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b0edee2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3b0edee2')) {
      api.createRecord('3b0edee2', component.options)
    } else {
      api.reload('3b0edee2', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=3b0edee2&scoped=true&", function () {
      api.rerender('3b0edee2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/layout/language/index.vue"
export default component.exports